import { useUserStore } from "@/stores/user";
// import {useFleetStore} from "@/stores/fleet";
import { useMomentaryStore } from "@/stores/momentary";
import { myAxios, myAxios2, myAxiosRetry } from "@/services/myAxios";
import { addIndexToArray } from "@/utils/utils";
import store from "@/store";
import { useDeviceStore } from "@/stores/device";
import { file } from "paths.macro";
import { useRoutesStore } from "@/stores/routes";
import { useCatalogsStore } from "@/stores/catalogs";
import axios from "axios";
import { useLogbookStore } from "@/stores/logbook";
import * as fxparser from "fast-xml-parser";
import { eventBus } from "@/main";
import JSZip from "jszip";
import notificationService from "@/views/dialogs/NotificationService";

let userStore, routesStore, deviceStore, momentaryStore, catalogsStore;


// Вспомогательная функция для загрузки и распаковки ZIP архивов
async function loadAndUnzipJson(zipUrl, jsonFileName) {
  try {
    console.log(`Загружаем ZIP архив: ${zipUrl}`);

    // Загружаем ZIP файл
    const response = await fetch(zipUrl);
    if (!response.ok) {
      throw new Error(`Не удалось загрузить ZIP архив: ${zipUrl}`);
    }

    const zipData = await response.arrayBuffer();

    // Распаковываем ZIP
    const zip = new JSZip();
    const zipContent = await zip.loadAsync(zipData);

    // Ищем нужный JSON файл в архиве
    const jsonFile = zipContent.file(jsonFileName);
    if (!jsonFile) {
      throw new Error(`Файл ${jsonFileName} не найден в архиве ${zipUrl}`);
    }

    // Читаем и парсим JSON
    const jsonText = await jsonFile.async("text");
    const jsonData = JSON.parse(jsonText);

    console.log(`Успешно загружен и распакован: ${jsonFileName} из ${zipUrl}`);
    return jsonData;
  } catch (error) {
    console.error(`Ошибка при загрузке ZIP архива ${zipUrl}:`, error);
    throw error;
  }
}

export function loadShips(isBackground = false) {
  userStore = useUserStore();
  // fleetStore = useFleetStore()
  routesStore = useRoutesStore();
  momentaryStore = useMomentaryStore();

  return new Promise((resolve) => {
    if (userStore.isShipsLoaded) {
      resolve();
    } else {
      let URL = "api/v1/installations/brief";
      const loadingKey = "ships";
      const loadingLabel = "Loading ships...";

      if (isBackground) {
        momentaryStore.startBackgroundLoading(loadingKey, loadingLabel);
      } else {
        momentaryStore.startCriticalLoading(loadingKey, loadingLabel);
      }

      momentaryStore.setBusy(true);
      momentaryStore.setAPIError(false);

      myAxiosRetry
        .get(URL)
        .then((resp) => {
          let ECDISList = resp.data.filter(function (e) {
            return (
              e.applicationId === 11 ||
              e.applicationId === 101 ||
              e.applicationId === 102 ||
              e.applicationId === 105
            );
          });

          let MkartList = resp.data.filter(function (e) {
            return (
              e.applicationId !== 11 &&
              e.applicationId !== 101 &&
              e.applicationId !== 102 &&
              e.applicationId !== 105
            );
          });

          ECDISList = addIndexToArray(ECDISList);
          MkartList = addIndexToArray(MkartList);

          // Сначала добавляем корабли в routesStore, чтобы при выборе корабля данные уже были доступны
          routesStore.addShips(ECDISList);
          
          userStore.addECDISShips({
            ecdisList: ECDISList,
            devicesList: MkartList,
          });
          // fleetStore.addInstallations(ECDISList)

          momentaryStore.setBusy(false);

          if (isBackground) {
            momentaryStore.stopBackgroundLoading(loadingKey);
          } else {
            momentaryStore.stopCriticalLoading(loadingKey);
          }

          resolve();
        })
        .catch((err) => {
          momentaryStore.setAPIError(true);
          momentaryStore.setBusy(false);

          if (isBackground) {
            momentaryStore.stopBackgroundLoading(loadingKey);
          } else {
            momentaryStore.stopCriticalLoading(loadingKey);
          }
        });
    }
  });
}

export function loadInstallations() {
  userStore = useUserStore();
  routesStore = useRoutesStore();
  momentaryStore = useMomentaryStore();
  // fleetStore = useFleetStore()

  return new Promise((resolve) => {
    if (userStore.isInstallationsLoaded) {
      resolve();
    } else {
      let URL = "api/v1/installations";

      momentaryStore.setBusy(true);
      momentaryStore.setAPIError(false);
      myAxios
        .get(URL)
        .then((resp) => {
          let instECDIS = resp.data.userInfos.filter(function (e) {
            return (
              e.applicationId === 11 ||
              e.applicationId === 101 ||
              e.applicationId === 102 ||
              e.applicationId === 105
            );
          });

          let instDevices = resp.data.userInfos.filter(function (e) {
            return (
              e.applicationId !== 11 &&
              e.applicationId !== 101 &&
              e.applicationId !== 102 &&
              e.applicationId !== 105
            );
          });

          instECDIS = addIndexToArray(instECDIS);
          instDevices = addIndexToArray(instDevices);

          if (instECDIS.length > 0) {
            userStore.addInstallations({
              ecdisList: instECDIS,
              devicesList: instDevices,
            });
            routesStore.addShips(instECDIS);

            // fleetStore.addInstallations(instECDIS)
          }
          momentaryStore.setBusy(false);
          resolve();
        })
        .catch((err) => {
          momentaryStore.setAPIError(true);
        });
    }
  });
}

export function loadAgreements(isBackground = false) {
  deviceStore = useDeviceStore();
  momentaryStore = useMomentaryStore();
  // fleetStore = useFleetStore()

  return new Promise((resolve) => {
    if (deviceStore.isAgreementLoaded) {
      resolve();
    } else {
      let URL = "api/v2/agreement";
      const loadingKey = "agreements";
      const loadingLabel = "Loading agreements...";

      if (isBackground) {
        momentaryStore.startBackgroundLoading(loadingKey, loadingLabel);
      } else {
        momentaryStore.startCriticalLoading(loadingKey, loadingLabel);
      }

      momentaryStore.setBusy(true);
      momentaryStore.setAPIError(false);

      myAxios
        .get(URL)
        .then((resp) => {
          deviceStore.addAgreements(resp.data);

          // fleetStore.addAgreements(resp.data)

          const userRole = store.state.auth.user.role;
          if (userRole === "distributor" || userRole === "supervisor") {
            let devices = [];
            resp.data.forEach(function (agreement) {
              // Если супервайзер, то показываем только корабли по 20-му договору или 47-му договору
              if (userRole === "supervisor") {
                const isMatchingAgreement = 
                  agreement.id == 20 || 
                  agreement.id == "20" || 
                  agreement.agreementId == 20 || 
                  agreement.agreementId == "20" || 
                  agreement.agreementId == "pGzNn7b5Yl" || 
                  agreement.displayId == 20 || 
                  agreement.displayId == "20" ||
                  (agreement.name && agreement.name.includes("20")) ||
                  agreement.id == "jXrNgB92K1" ||
                  agreement.agreementId == "jXrNgB92K1" ||
                  agreement.displayId == 47 ||
                  agreement.displayId == "47";
                
                if (!isMatchingAgreement) return;
              }

              agreement.users.forEach(function (user) {
                devices.push({
                  deviceId: user.deviceId,
                  applicationId: user.applicationId,
                  shipName: user.shipName + " (" + agreement.name + ")",
                  email: user.email,
                });
              });
            });
            devices = addIndexToArray(devices);
            userStore.addECDISAgreementShips({ ecdisList: devices });
            routesStore.addShips(devices);
          }

          momentaryStore.setBusy(false);

          if (isBackground) {
            momentaryStore.stopBackgroundLoading(loadingKey);
          } else {
            momentaryStore.stopCriticalLoading(loadingKey);
          }

          resolve();
        })
        .catch((err) => {
          momentaryStore.setAPIError(true);
          momentaryStore.setBusy(false);

          if (isBackground) {
            momentaryStore.stopBackgroundLoading(loadingKey);
          } else {
            momentaryStore.stopCriticalLoading(loadingKey);
          }
        });
    }
  });
}

export function updateOrderStatus(orderId, orderStatus) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve, reject) => {
    let URL = "api/v2/order/" + orderId + "/update-status/" + orderStatus;

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxios
      .post(URL)
      .then(() => {
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch(() => {
        momentaryStore.setAPIError(true);
        reject();
      });
  });
}

export function loadMSSChartsByLegs(points) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve, reject) => {
    let URL = "api/v1/mss/mapswithlegs";

    if (points.length === 0) {
      reject();
      return;
    }

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxios
      .post(URL, points)
      .then((resp) => {
        momentaryStore.addChartsByLegs(resp.data);
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch((err) => {
        momentaryStore.setAPIError(true);
        reject();
      });
  });
}

// Хелпер для API-запросов
const makeApiRequest = async (url, method = 'get', data = null, customAxios = myAxios) => {
  momentaryStore = useMomentaryStore();

  momentaryStore.setBusy(true)
  momentaryStore.setAPIError(false)

  try {
    const response = method === 'get' ? await customAxios.get(url) : await customAxios.post(url, data)

    momentaryStore.setBusy(false)
    return response.data
  } catch (error) {
    momentaryStore.setBusy(false)
    momentaryStore.setAPIError(true)
    throw error
  }
}

// Загружает доступные карты по координатам точки
export async function loadMapsForFolio(points, providers = ['Primar']) {
  momentaryStore = useMomentaryStore();
  routesStore = useRoutesStore();

  try {
    // Формируем данные для запроса
    const requestData = {
      Points: points,
      Providers: providers,
    }

    // Выполняем запрос к API
    const data = await makeApiRequest('api/v1/maps-by-legs', 'post', requestData, myAxiosRetry)

    // Обрабатываем ответ для каждого провайдера
    let chartsByLegs = {}

    if (data && data.length > 0) {
      data.forEach(providerData => {
        if (providerData.legsInfo && providerData.legsInfo.length > 0) {
          // Для каждого лега собираем уникальные карты
          providerData.legsInfo.forEach((legInfo, legIndex) => {
            const legNumber = legIndex + 1 // Номера легов начинаются с 1
            const uniqueMapIds = new Set()
            
            if (legInfo.mapIntersections && legInfo.mapIntersections.length > 0) {
              // Извлекаем id карт для текущего лега
              legInfo.mapIntersections.forEach(intersection => {
                if (intersection.id && intersection.id !== 'PAYSF') {
                  uniqueMapIds.add(intersection.id)
                }
              })
            }

            // Преобразуем Set в массив и сортируем
            const mapsForLeg = Array.from(uniqueMapIds).sort((a, b) => a.localeCompare(b))

            // Если у нас еще нет записи для этого лега, создаем ее
            if (!chartsByLegs[legNumber]) {
              chartsByLegs[legNumber] = mapsForLeg
            } else {
              // Если запись уже есть, объединяем карты (для случая нескольких провайдеров)
              const existingMaps = new Set(chartsByLegs[legNumber])
              const newMaps = new Set(mapsForLeg)
              const combinedMaps = new Set([...existingMaps, ...newMaps])
              
              chartsByLegs[legNumber] = Array.from(combinedMaps).sort((a, b) => a.localeCompare(b))
            }
          })
        }
      })
    }

    // Сохраняем результат в Pinia momentary store
    console.log('Charts by legs processed:', chartsByLegs)
    momentaryStore.addChartsByLegs(chartsByLegs)

    return chartsByLegs
  } catch (error) {
    console.error('Failed to load maps by coordinates:', error)
    return {}
  }
}

export function loadDatasetByLegs(points, providers = ["Primar"], bufferInKm = 0) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve, reject) => {
    let URL = "api/v1/maps-by-legs";

    if (points.length === 0) {
      reject();
      return;
    }

    let request = {
      Providers: providers,
      Points: points,
      BufferInKm: bufferInKm
    };

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxios
      .post(URL, request)
      .then((resp) => {
        momentaryStore.addDatasetByLegs(resp.data);

        // Create collections for each provider type
        const primarData = resp.data.find((item) => item.provider === "Primar");
        const avcsData = resp.data.find((item) => item.provider === "avcs");
        const enpData = resp.data.find((item) => item.provider === "enp");
        // const adpData = resp.data.filter(item =>
        //     ['radio', 'light', 'tide'].includes(item.provider));

        const adpData = resp.data
          .filter((item) => ["radio", "light", "tide"].includes(item.provider))
          .reduce((combined, item) => {
            // Merge the current item into the combined object
            return {
              ...combined,
              ...item,
              // If both have legsInfo, combine them
              legsInfo:
                combined.legsInfo && item.legsInfo
                  ? [...combined.legsInfo, ...item.legsInfo]
                  : combined.legsInfo || item.legsInfo || [],
              provider: "adp", // Set a common provider name for the merged object
            };
          }, {});

        console.log("uniq adp", adpData);
        console.log("uniq enp", enpData);

        const uniqueIds = new Set();
        const uniqueIdsENP = new Set();
        const uniqueIdsADP = new Set();

        // Process primary ENC charts
        if (primarData && primarData.legsInfo) {
          primarData.legsInfo.forEach((leg) => {
            if (leg.mapIntersections) {
              leg.mapIntersections.forEach((intersection) => {
                if (intersection.id && intersection.id !== "PAYSF") {
                  uniqueIds.add(intersection.id);
                }
              });
            }
          });
        }

        // Process AVCS charts
        if (avcsData && avcsData.legsInfo) {
          avcsData.legsInfo.forEach((leg) => {
            if (leg.mapIntersections) {
              leg.mapIntersections.forEach((intersection) => {
                if (intersection.id && intersection.id !== "PAYSF") {
                  uniqueIds.add(intersection.id);
                }
              });
            }
          });
        }

        if (enpData && enpData.legsInfo) {
          enpData.legsInfo.forEach((leg) => {
            if (leg.mapIntersections) {
              leg.mapIntersections.forEach((intersection) => {
                if (intersection.id && intersection.id !== "PAYSF") {
                  uniqueIdsENP.add(intersection.id);
                }
              });
            }
          });
        }

        if (adpData && adpData.legsInfo) {
          adpData.legsInfo.forEach((leg) => {
            if (leg.mapIntersections) {
              leg.mapIntersections.forEach((intersection) => {
                if (intersection.id && intersection.id !== "PAYSF") {
                  uniqueIdsADP.add(intersection.id);
                }
              });
            }
          });
        }

        console.log("uniqueIds", uniqueIds);
        console.log("uniqueIdsENP", uniqueIdsENP);
        console.log("uniqueIdsADP", uniqueIdsADP);

        momentaryStore.addChartsByRoute(Array.from(uniqueIds));
        momentaryStore.addENPByRoute(Array.from(uniqueIdsENP));
        momentaryStore.addADPByRoute(Array.from(uniqueIdsADP));
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch((err) => {
        momentaryStore.setAPIError(true);
        reject();
      });
  });
}

// export function loadPubsByLegs(points) {
//     momentaryStore = useMomentaryStore()
//
//     function load_Pub(points, provider) {
//         return new Promise((resolve, reject) => {
//             let URL = "api/v1/maps-by-legs"
//
//             if (points.length === 0) {
//                 reject()
//                 return
//             }
//
//             let request = {
//                 Providers: provider,
//                 Points: points
//             }
//
//             momentaryStore.setBusy(true);
//             momentaryStore.setAPIError(false)
//             myAxios.post(URL, request).then(resp => {
//                 momentaryStore.addDatasetByLegs(resp.data)
//
//                 const uniqueIds = new Set();
//                 if (resp.data[0] && resp.data[0].legsInfo) {
//                     resp.data[0].legsInfo.forEach(leg => {
//                         if (leg.mapIntersections) {
//                             leg.mapIntersections.forEach(intersection => {
//                                 if (intersection.id && intersection.id !== 'PAYSF') {
//                                     uniqueIds.add(intersection.id);
//                                 }
//                             });
//                         }
//                     });
//                 }
//
//                 console.log("uniqueIds", provider, uniqueIds)
//                 // momentaryStore.addChartsByRoute(Array.from(uniqueIds))
//                 momentaryStore.setBusy(false);
//                 resolve();
//             }).catch(err => {
//                 momentaryStore.setAPIError(true)
//                 reject()
//             });
//         })
//     }
//
//     return new Promise(resolve => {
//         let encRequests = [load_Pub(points, "enp"), load_Pub(points, "tide")]
//         Promise.allSettled(encRequests).then(([r1, r2]) => {
//             resolve()
//         })
//     })
//
//     return new Promise((resolve, reject) => {
//         let URL = "api/v1/maps-by-legs"
//
//         if (points.length === 0) {
//             reject()
//             return
//         }
//
//         let request = {
//             Providers: [provider],
//             Points: points
//         }
//
//         momentaryStore.setBusy(true);
//         momentaryStore.setAPIError(false)
//         myAxios.post(URL, request).then(resp => {
//             momentaryStore.addDatasetByLegs(resp.data)
//
//             const uniqueIds = new Set();
//             if (resp.data[0] && resp.data[0].legsInfo) {
//                 resp.data[0].legsInfo.forEach(leg => {
//                     if (leg.mapIntersections) {
//                         leg.mapIntersections.forEach(intersection => {
//                             if (intersection.id && intersection.id !== 'PAYSF') {
//                                 uniqueIds.add(intersection.id);
//                             }
//                         });
//                     }
//                 });
//             }
//
//             momentaryStore.addChartsByRoute(Array.from(uniqueIds))
//             momentaryStore.setBusy(false);
//             resolve();
//         }).catch(err => {
//             momentaryStore.setAPIError(true)
//             reject()
//         });
//     })
// }

export function loadDataByPoint(point) {
  return new Promise((resolve, reject) => {
    let URL = "api/v1/maps-by-legs";

    let request = {
      Providers: ["Primar"],
      Points: [point],
    };

    myAxios
      .post(URL, request)
      .then((resp) => {
        const uniqueIds = new Set();

        if (resp.data[0] && resp.data[0].legsInfo) {
          resp.data[0].legsInfo.forEach((leg) => {
            if (leg.mapIntersections) {
              leg.mapIntersections.forEach((intersection) => {
                if (intersection.id) {
                  uniqueIds.add(intersection.id);
                }
              });
            }
          });
        }

        const sortedIds = Array.from(uniqueIds).sort((a, b) => {
          if (a.length >= 3 && b.length >= 3) {
            return a[2].localeCompare(b[2]);
          }
          return a.localeCompare(b);
        });

        resolve(sortedIds);
      })
      .catch((err) => {
        //TODO
        momentaryStore.setAPIError(true);
        reject();
      });
  });
}

export function load2DImage(coordinates, cog, repeat = false) {
  momentaryStore = useMomentaryStore();
  routesStore = useRoutesStore();

  // routesStore.getShipDraught
  // routesStore.getShipWidth
  // routesStore.getShipLength

  return new Promise((resolve) => {
    let URL = "api/v1/ship_seabed";

    let xclip = 30;
    let yclip = 30;

    let data = momentaryStore.getShipImageRequest;

    if (repeat) {
      if (
        xclip + momentaryStore.getShipImageRequestOffset * 10 >= 0 &&
        yclip + momentaryStore.getShipImageRequestOffset * 10 >= 0
      ) {
        xclip += momentaryStore.getShipImageRequestOffset * 10;
        yclip += momentaryStore.getShipImageRequestOffset * 10;
      } else {
        xclip = data.imageInfo.xClip;
        yclip = data.imageInfo.yClip;
      }
    }

    console.log(momentaryStore.getShipImageRequestOffset, xclip, yclip);

    if (!repeat) {
      data = {
        shipInfo: {
          draught: routesStore.getShipDraught,
          width: routesStore.getShipWidth,
          length: routesStore.getShipLength,
          xPos: 3,
        },
        positionInfo: {
          lat: coordinates.lat,
          lon: coordinates.lng,
          cog: cog,
        },
        imageInfo: {
          xClip: xclip,
          yClip: yclip,
          autoCalcClip: false,
        },
      };
    } else {
      data.imageInfo.xClip = xclip;
      data.imageInfo.yClip = yclip;
    }

    momentaryStore.set2DImageRequest(data);

    myAxios2
      .post(URL, data)
      .then((resp) => {
        console.log("img resp", resp.data);
        const base64Image = resp.data; // Assuming resp.data contains the base64 string

        const src = `data:image/png;base64,${base64Image}`;
        resolve(src);
      })
      .catch((err) => {});
  });
}

export function loadMSSChartsByRoute(points) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve) => {
    let URL = "api/v1/mss/maps";

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxios
      .post(URL, points)
      .then((resp) => {
        momentaryStore.addChartsByRoute(resp.data);
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch((err) => {
        momentaryStore.setAPIError(true);
      });
  });
}

export function loadMSSADPByRoute(points) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve) => {
    let URL = "api/v1/mss/adp";

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxiosRetry
      .post(URL, points)
      .then((resp) => {
        momentaryStore.addADPByRoute(resp.data);
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch((err) => {
        momentaryStore.setAPIError(true);
      });
  });
}

export function loadMSSENPByRoute(points) {
  momentaryStore = useMomentaryStore();

  return new Promise((resolve) => {
    let URL = "api/v1/mss/enp";

    momentaryStore.setBusy(true);
    momentaryStore.setAPIError(false);
    myAxiosRetry
      .post(URL, points)
      .then((resp) => {
        console.log("aaaa enp res", resp.data);
        momentaryStore.addENPByRoute(resp.data);
        momentaryStore.setBusy(false);
        resolve();
      })
      .catch((err) => {
        momentaryStore.setAPIError(true);
      });
  });
}

export function loadMSSDataByRoute(points) {
  return new Promise((resolve) => {
    let encRequests = [
      loadMSSChartsByRoute(points),
      loadMSSADPByRoute(points),
      loadMSSENPByRoute(points),
    ];
    Promise.allSettled(encRequests).then(([r1, r2, r3]) => {
      resolve();
    });
  });
}

// export function loadCells(sourceType) {
//     return new Promise(resolve => {
//         store.commit("fickle/setPrimarENCDataReady", true)
//         store.commit("fickle/setENCDataLoading", true)
//
//         let encRequests
//         if (sourceType === 'primar')
//             encRequests = [store.dispatch("getENCCountries_Primar"), store.dispatch("getENCProducts_Primar"), store.dispatch("getENCs_Primar")]
//         else if (sourceType === 'ukho')
//             encRequests = [store.dispatch("getENCCountries_Primar"), store.dispatch("getENCProducts_UKHO"), store.dispatch("getENCs_UKHO")]
//         else
//             alert("Error")
//
//         Promise.allSettled(encRequests).then(([r1, r2, r3]) => {
//             let mapInfos = r3.value
//             let errorFlag = false
//             let links = store.state.charts.s63.products.linksToProducts;
//             mapInfos.forEach(item => {
//                 item.productId = links[item.id];
//                 if (!item.productId) {
//                     // alert(item.id)
//                     errorFlag = true
//                 }
//             })
//
//             if (errorFlag) {
//                 // alert('Primar is not available, ' + file)
//                 console.log('PROBLEMA, ' + file)
//             }
//
//             store.commit("addPrimarMapInfos", Object.freeze(mapInfos));
//             store.commit("fickle/setENCDataLoading", false)
//
//             resolve(true)
//         })
//     })
//
// }

export function loadShipOrders(deviceId) {
  // userStore = useUserStore()
  // deviceStore = useDeviceStore()
  momentaryStore = useMomentaryStore();

  // console.log("deviceId", deviceId)
  // console.log("deviceStore", deviceStore)
  // console.log("deviceStore.getAgreementProvider", deviceStore.getAgreementProvider)
  // let URL = ''
  // if (deviceStore.getAgreementProvider === 'Primar') {
  //     URL = "/api/v1/orders/deviceid/" + deviceId;
  //     console.log("Primar")
  // } else if (deviceStore.getAgreementProvider === 'UKHO') {
  //     URL = "/api/v1/mss/summary/deviceid/" + deviceId
  //     console.log("UKHO")
  // }

  momentaryStore.setOrdersBusy(true);

  let URL1 = "/api/v1/orders/deviceid/" + deviceId;
  let URL2 = "/api/v1/mss/summary/deviceid/" + deviceId;
  return new Promise((resolve, reject) => {
    Promise.allSettled([myAxiosRetry.get(URL1), myAxiosRetry.get(URL2)]).then(
      ([resp1, resp2]) => {
        momentaryStore.setOrdersBusy(false);

        console.log("resp1", resp1.data);
        console.log("resp2", resp2.data);

        //     if (resp1.status === 'fulfilled' && resp1.value.data && resp1.value.data.length > 0) {
        //         resolve(resp1.value);
        //     } else if (resp2.status === 'fulfilled' && resp2.value.data && resp2.value.data.length > 0) {
        //         resolve(resp2.value);
        //     } else if (resp1.status === 'fulfilled') {
        //         resolve(resp1.value);
        //     } else if (resp2.status === 'fulfilled') {
        //         resolve(resp2.value);
        //     } else {
        //         reject(new Error("Both requests failed"));
        //     }
        // });
      }
    );

    // userStore = useUserStore()
    // momentaryStore = useMomentaryStore()
    //
    // const dataAlreadyLoaded = userStore.ordersByDevices.some(e => e.id === deviceId)
    // if (dataAlreadyLoaded)
    //     return
    //
    // momentaryStore.setOrdersBusy(true);
    // return new Promise(resolve => {
    //     let URL = "api/v1/orders/";
    //     myAxiosRetry.get(URL).then(resp => {
    //         userStore.addOrders({orders: resp.data, id: deviceId})
    //         momentaryStore.setOrdersBusy(false);
    //         resolve();
    //     });
    // })
  });
}

// export function loadTransactions() {
//     // fleetStore = useFleetStore()
//
//     let URL = "api/v1/orders";
//     myAxiosRetry.get(URL).then(resp => {
//         fleetStore.addOrders(resp.data)
//     });
// }

export function loadDeliveries(deviceId) {
  userStore = useUserStore();
  momentaryStore = useMomentaryStore();

  const dataAlreadyLoaded = userStore.ordersByDevices.some(
    (e) => e.id === deviceId
  );
  if (dataAlreadyLoaded) return;

  momentaryStore.setOrdersBusy(true);
  return new Promise((resolve) => {
    let URL = "api/v1/orders/";
    myAxiosRetry.get(URL).then((resp) => {
      userStore.addOrders({ orders: resp.data, id: deviceId });
      momentaryStore.setOrdersBusy(false);
      resolve();
    });
  });
}

export function loadDeliveries1(deviceId, period) {
  deviceStore = useDeviceStore();
  let data = {
    deviceIds: [deviceId],
    dateFrom: period, // TODO dateFrom: dayjs().add(-1, "day")
  };

  return new Promise((resolve) => {
    let URL = "api/v1/deliveries";
    myAxios.post(URL, data).then((resp) => {
      let deliveries = [];
      if (resp.data.deliveries.length > 0) {
        deliveries = resp.data.deliveries.filter(
          (d) => d.deviceId === deviceStore.getDeviceID
        )[0].deliveries;
        deliveries.forEach((item) => {
          item.ship = deviceStore.getShipName;
        });
      }
      deviceStore.addDeliveries(deliveries);
      resolve();
    });
  });
}

export function getTotalPrice(provider, data, id) {
  console.log("getTotalPrice", provider, data, id);
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/orders/primar/quotate/v3";
    myAxios
      .post(URL, data, {
        headers: {
          "X-Request-ID": id,
        },
      })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        console.error("Error calculating order cost:", err);

        // Показываем toast уведомление об ошибке
        if (err.response && err.response.data) {
          const errorMessage = err.response.data.detail;
          console.error("Error details:", errorMessage);
          momentaryStore.setAPIError(true, errorMessage);
        } else {
          momentaryStore.setAPIError(true, "An unknown error occurred");
        }

        reject(err);
      });
  });
}

export function getENPADPPrice(data, id) {
  console.log("enp getENPADPPrice");
  return new Promise((resolve, reject) => {
    if (data.length === 0) {
      let uoses = [];
      let resp = { data: uoses };
      resolve(resp);
      return;
    }

    let URL = "api/v1/mss/uosesquotate";
    myAxios
      .post(URL, data, {
        headers: {
          "X-Request-ID": id,
        },
      })
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function loadUKHO_eNP() {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/mss/catalog/enp";
    myAxios
      .get(URL)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

function loadUKHO_ADP1() {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/mss/catalog/radio";
    myAxios
      .get(URL)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

function loadUKHO_ADP2() {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/mss/catalog/tide";
    myAxios
      .get(URL)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

function loadUKHO_ADP3() {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/mss/catalog/light";
    myAxios
      .get(URL)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

// ===== DEPRECATED: Старые функции загрузки каталогов =====
// Эти функции заменены на catalogService.js и catalog.js store
// Оставлены для совместимости, но не используются в prepareCatalog()

function _deprecated_loadUKHO_AVCS(useLocalData = false, useZipArchive = false) {
  return new Promise((resolve, reject) => {
    if (useZipArchive) {
      // Use ZIP archive for UKHO AVCS
      loadAndUnzipJson("/ukho/avcs.zip", "avcs.json")
        .then((data) => {
          if (!data) {
            throw new Error("Invalid data format in avcs.zip archive");
          }
          resolve(data);
        })
        .catch((error) => {
          console.error("Error loading ZIP archive avcs.zip:", error);
          // Fallback to local data if ZIP loading failed
          if (useLocalData) {
            loadFromLocal()
              .then((data) => resolve(data))
              .catch(() =>
                loadFromAPI()
                  .then((data) => resolve(data))
                  .catch((apiError) => reject(apiError))
              );
          } else {
            loadFromAPI()
              .then((data) => resolve(data))
              .catch((apiError) => reject(apiError));
          }
        });
    } else if (useLocalData) {
      // Use local JSON file
      loadFromLocal()
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Error loading local UKHO AVCS data:", error);
          // Fallback to API if local loading failed
          loadFromAPI()
            .then((data) => resolve(data))
            .catch((apiError) => reject(apiError));
        });
    } else {
      // Use API as usual
      loadFromAPI()
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }

    // Helper function for loading local JSON files
    function loadFromLocal() {
      return new Promise((resolveLocal, rejectLocal) => {
        fetch("/ukho/avcs.json")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to load local file avcs.json");
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              throw new Error("Invalid data format in local file avcs.json");
            }
            resolveLocal(data);
          })
          .catch((error) => rejectLocal(error));
      });
    }

    // Helper function for loading from API
    function loadFromAPI() {
      return new Promise((resolveAPI, rejectAPI) => {
        let URL = "/api/v1/mss/catalog/enc";
        myAxios
          .get(URL, {
            headers: {
              "Accept-Encoding": "gzip, deflate, br",
            },
          })
          .then((resp) => {
            resolveAPI(resp.data);
          })
          .catch((err) => {
            console.error("Error loading UKHO AVCS data from API:", err);
            rejectAPI(err);
          });
      });
    }
  });
}

// function loadPrimar_ENC() {
//     return new Promise((resolve, reject) => {
//         alert(3)
//         let URL = "/api/v1/primar/enc"
//         myAxios.get(URL).then(resp => {
//             resolve(resp.data)
//         });
//     })
// }

// function loadALL_Countries() {
//     catalogsStore = useCatalogsStore()
//
//     return new Promise(resolve => {
//         let URL = "/api/v1/primar/countries"
//         myAxios.get(URL).then(resp => {
//             catalogsStore.addCountries(resp.data)
//             resolve()
//         });
//     })
// }

// function loadPrimar_Products() {
//     catalogsStore = useCatalogsStore()
//
//     return new Promise((resolve, reject) => {
//         let URL = "/api/v1/primar/products"
//         myAxios.get(URL).then(resp => {
//             let json = resp.data
//
//             let itemsS57 = {};
//             let linksS57 = {};
//
//             let indexENC = json.productTypes.findIndex((a) => a.description === 'S-57 ENC')
//             let productsS75 = json.productTypes.at(indexENC).productList.products;
//
//             productsS75.forEach(product => {
//                 if (product.productCellList) {
//                     if (product.productCellList.productCells.length > 1) {
//                         itemsS57[product.id] = product;
//                     }
//                     product.productCellList.productCells.forEach(cell => {
//                         linksS57[cell.id] = product.id
//                     })
//                 }
//             })
//
//             catalogsStore.addProducts(productsS75)
//             catalogsStore.addMultiItems(itemsS57)
//             catalogsStore.addLinks(linksS57)
//             resolve(json)
//         });
//     })
// }

// DEPRECATED: Загрузка каталога Primar Countries (заменена на catalogService)
function _deprecated_loadALL_Countries(useLocalData = false, useZipArchive = false) {
  catalogsStore = useCatalogsStore();

  return new Promise((resolve, reject) => {
    if (useZipArchive) {
      // Используем ZIP архив
      loadAndUnzipJson("/primar/countries.zip", "countries.json")
        .then((data) => {
          if (!data) {
            throw new Error("Некорректный формат данных в архиве counties.zip");
          }
          catalogsStore.addCountries(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Ошибка при загрузке ZIP архива countries.zip:", error);
          // Если ZIP загрузка не удалась, пробуем обычные локальные данные
          if (useLocalData) {
            loadFromLocal()
              .then((data) => resolve(data))
              .catch(() =>
                loadFromAPI()
                  .then((data) => resolve(data))
                  .catch((apiError) => reject(apiError))
              );
          } else {
            loadFromAPI()
              .then((data) => resolve(data))
              .catch((apiError) => reject(apiError));
          }
        });
    } else if (useLocalData) {
      // Используем локальные данные из файла
      loadFromLocal()
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Ошибка при загрузке локальных данных:", error);
          // Если локальная загрузка не удалась, пробуем API как запасной вариант
          loadFromAPI()
            .then((data) => resolve(data))
            .catch((apiError) => reject(apiError));
        });
    } else {
      // Используем API как обычно
      loadFromAPI()
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }

    // Вспомогательная функция для загрузки локальных JSON файлов
    function loadFromLocal() {
      return new Promise((resolveLocal, rejectLocal) => {
        fetch("/primar/countries.json")
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                "Не удалось загрузить локальный файл countries.json"
              );
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              throw new Error(
                "Некорректный формат данных в локальном файле countries.json"
              );
            }
            catalogsStore.addCountries(data);
            resolveLocal(data);
          })
          .catch((error) => rejectLocal(error));
      });
    }

    // Вспомогательная функция для загрузки с API
    function loadFromAPI() {
      return new Promise((resolveAPI, rejectAPI) => {
        let URL = "/api/v1/primar/countries";
        myAxios
          .get(URL, {
            headers: {
              "Accept-Encoding": "gzip, deflate, br",
            },
          })
          .then((resp) => {
            catalogsStore.addCountries(resp.data);
            resolveAPI(resp.data);
          })
          .catch((err) => {
            console.error("Ошибка при загрузке данных с API:", err);
            rejectAPI(err);
          });
      });
    }
  });
}

// DEPRECATED: Загрузка каталога Primar Products (заменена на catalogService)
function _deprecated_loadPrimar_Products(useLocalData = false, useZipArchive = false) {
  catalogsStore = useCatalogsStore();

  return new Promise((resolve, reject) => {
    if (useZipArchive) {
      // Используем ZIP архив
      loadAndUnzipJson("/primar/products.zip", "products.json")
        .then((data) => {
          if (!data) {
            throw new Error("Некорректный формат данных в архиве products.zip");
          }
          processProductsData(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Ошибка при загрузке ZIP архива products.zip:", error);
          // Если ZIP загрузка не удалась, пробуем обычные локальные данные
          if (useLocalData) {
            loadFromLocal()
              .then((data) => resolve(data))
              .catch(() =>
                loadFromAPI()
                  .then((data) => resolve(data))
                  .catch((apiError) => reject(apiError))
              );
          } else {
            loadFromAPI()
              .then((data) => resolve(data))
              .catch((apiError) => reject(apiError));
          }
        });
    } else if (useLocalData) {
      // Используем локальные данные из файла
      loadFromLocal()
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Ошибка при загрузке локальных данных:", error);
          // Если локальная загрузка не удалась, пробуем API как запасной вариант
          loadFromAPI()
            .then((data) => resolve(data))
            .catch((apiError) => reject(apiError));
        });
    } else {
      // Используем API как обычно
      loadFromAPI()
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }

    // Вспомогательная функция для обработки данных продуктов
    function processProductsData(json) {
      let itemsS57 = {};
      let linksS57 = {};

      let indexENC = json.productTypes.findIndex(
        (a) => a.description === "S-57 ENC"
      );
      let productsS75 = json.productTypes.at(indexENC).productList.products;

      productsS75.forEach((product) => {
        if (product.productCellList) {
          if (product.productCellList.productCells.length > 1) {
            itemsS57[product.id] = product;
          }
          product.productCellList.productCells.forEach((cell) => {
            linksS57[cell.id] = product.id;
          });
        }
      });

      catalogsStore.addProducts(productsS75);
      catalogsStore.addMultiItems(itemsS57);
      catalogsStore.addLinks(linksS57);
    }

    // Вспомогательная функция для загрузки локальных JSON файлов
    function loadFromLocal() {
      return new Promise((resolveLocal, rejectLocal) => {
        fetch("/primar/products.json")
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                "Не удалось загрузить локальный файл products.json"
              );
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              throw new Error(
                "Некорректный формат данных в локальном файле products.json"
              );
            }
            processProductsData(data);
            resolveLocal(data);
          })
          .catch((error) => rejectLocal(error));
      });
    }

    // Вспомогательная функция для загрузки с API
    function loadFromAPI() {
      return new Promise((resolveAPI, rejectAPI) => {
        let URL = "/api/v1/primar/products";
        myAxios
          .get(URL, {
            headers: {
              "Accept-Encoding": "gzip, deflate, br",
            },
          })
          .then((resp) => {
            processProductsData(resp.data);
            resolveAPI(resp.data);
          })
          .catch((err) => {
            console.error("Ошибка при загрузке данных с API:", err);
            rejectAPI(err);
          });
      });
    }
  });
}

// DEPRECATED: Загрузка каталога Primar ENC (заменена на catalogService)
function _deprecated_loadPrimar_ENC(useLocalData = false, useZipArchive = false) {
  return new Promise((resolve, reject) => {
    if (useZipArchive) {
      // Используем ZIP архив
      loadAndUnzipJson("/primar/enc.zip", "enc.json")
        .then((data) => {
          if (!data) {
            throw new Error("Некорректный формат данных в архиве enc.zip");
          }
          resolve(data);
        })
        .catch((error) => {
          console.error("Ошибка при загрузке ZIP архива enc.zip:", error);
          // Если ZIP загрузка не удалась, пробуем обычные локальные данные
          if (useLocalData) {
            loadFromLocal()
              .then((data) => resolve(data))
              .catch(() =>
                loadFromAPI()
                  .then((data) => resolve(data))
                  .catch((apiError) => reject(apiError))
              );
          } else {
            loadFromAPI()
              .then((data) => resolve(data))
              .catch((apiError) => reject(apiError));
          }
        });
    } else if (useLocalData) {
      // Используем локальные данные из файла
      loadFromLocal()
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Ошибка при загрузке локальных данных:", error);
          // Если локальная загрузка не удалась, пробуем API как запасной вариант
          loadFromAPI()
            .then((data) => resolve(data))
            .catch((apiError) => reject(apiError));
        });
    } else {
      // Используем API как обычно
      loadFromAPI()
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }

    // Вспомогательная функция для загрузки локальных JSON файлов
    function loadFromLocal() {
      return new Promise((resolveLocal, rejectLocal) => {
        fetch("/primar/enc.json")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Не удалось загрузить локальный файл enc.json");
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              throw new Error(
                "Некорректный формат данных в локальном файле enc.json"
              );
            }
            resolveLocal(data);
          })
          .catch((error) => rejectLocal(error));
      });
    }

    // Вспомогательная функция для загрузки с API
    function loadFromAPI() {
      return new Promise((resolveAPI, rejectAPI) => {
        let URL = "/api/v1/primar/enc";
        myAxios
          .get(URL, {
            headers: {
              "Accept-Encoding": "gzip, deflate, br",
            },
          })
          .then((resp) => {
            resolveAPI(resp.data);
          })
          .catch((err) => {
            console.error("Ошибка при загрузке данных с API:", err);
            rejectAPI(err);
          });
      });
    }
  });
}

function _deprecated_loadPrimar_Test1() {
  return new Promise((resolve, reject) => {
    fetch("/primar/a1.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Не удалось загрузить локальный файл a1.json");
        }
        return response.json();
      })
      .then((data) => {
        // Проверяем, что данные корректны
        if (!data) {
          throw new Error(
            "Некорректный формат данных в локальном файле a1.json"
          );
        }
        resolve(data);
      });
  });
}

function _deprecated_loadPrimar_Test2() {
  return new Promise((resolve, reject) => {
    fetch("/primar/a2.json.gz")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Не удалось загрузить локальный файл a2.json.gz");
        }
        return response.json();
      })
      .then((data) => {
        // Проверяем, что данные корректны
        if (!data) {
          throw new Error(
            "Некорректный формат данных в локальном файле a2.json.gz"
          );
        }
        resolve(data);
      });
  });
}

// DEPRECATED: Загрузка каталога UKHO Products (заменена на catalogService)
function _deprecated_loadUKHO_Products(useLocalData = false, useZipArchive = false) {

  return new Promise((resolve, reject) => {
    if (useZipArchive) {
      // Use ZIP archive for UKHO products
      loadAndUnzipJson("/ukho/products.zip", "products.json")
        .then((data) => {
          if (!data) {
            throw new Error("Invalid data format in products.zip archive");
          }
          processUKHOProductsData(data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Error loading ZIP archive products.zip:", error);
          // Fallback to local data if ZIP loading failed
          if (useLocalData) {
            loadFromLocal()
              .then((data) => resolve(data))
              .catch(() =>
                loadFromAPI()
                  .then((data) => resolve(data))
                  .catch((apiError) => reject(apiError))
              );
          } else {
            loadFromAPI()
              .then((data) => resolve(data))
              .catch((apiError) => reject(apiError));
          }
        });
    } else if (useLocalData) {
      // Use local JSON file
      loadFromLocal()
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Error loading local UKHO products data:", error);
          // Fallback to API if local loading failed
          loadFromAPI()
            .then((data) => resolve(data))
            .catch((apiError) => reject(apiError));
        });
    } else {
      // Use API as usual
      loadFromAPI()
        .then((data) => resolve(data))
        .catch((err) => reject(err));
    }

    // Helper function for processing UKHO products data
    function processUKHOProductsData(json) {
      let itemsS57 = {};
      let linksS57 = {};

      let indexENC = json.productTypes.findIndex(
        (a) => a.description === "avcs"
      );
      let productsS75 = json.productTypes.at(indexENC).productList.products;

      productsS75.forEach((product) => {
        if (product.productCellList) {
          if (product.id !== "PAYSF") {
            if (product.productCellList.productCells.length > 1) {
              itemsS57[product.id] = product;
            }
            product.productCellList.productCells.forEach((cell) => {
              linksS57[cell.id] = product.id;
            });
          }
        }
      });

      catalogsStore.addProducts(productsS75);
      catalogsStore.addMultiItems(itemsS57);
      catalogsStore.addLinks(linksS57);
    }

    // Helper function for loading local JSON files
    function loadFromLocal() {
      return new Promise((resolveLocal, rejectLocal) => {
        fetch("/ukho/products.json")
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to load local file products.json");
            }
            return response.json();
          })
          .then((data) => {
            if (!data) {
              throw new Error(
                "Invalid data format in local file products.json"
              );
            }
            processUKHOProductsData(data);
            resolveLocal(data);
          })
          .catch((error) => rejectLocal(error));
      });
    }

    // Helper function for loading from API
    function loadFromAPI() {
      return new Promise((resolveAPI, rejectAPI) => {
        let URL = "/api/v1/mss/catalog/avcs";
        myAxios
          .get(URL, {
            headers: {
              "Accept-Encoding": "gzip, deflate, br",
            },
          })
          .then((resp) => {
            processUKHOProductsData(resp.data);
            resolveAPI(resp.data);
          })
          .catch((err) => {
            console.error("Error loading UKHO products data from API:", err);
            rejectAPI(err);
          });
      });
    }
  });
}

export function loadUKHO_Publications() {
  catalogsStore = useCatalogsStore();
  deviceStore = useDeviceStore();
  return new Promise((resolve, reject) => {
    let encRequests = [];
    if (deviceStore.getAgreementProvider === "UKHO")
      encRequests = [
        loadUKHO_ADP1(),
        loadUKHO_ADP2(),
        loadUKHO_ADP3(),
        loadUKHO_eNP(),
      ];

    Promise.allSettled(encRequests)
      .then(([r1, r2, r3, r4]) => {
        console.log("aaaa ADP", r1.value, r2.value, r3.value, r4.value);

        catalogsStore.addADP1(r1.value);
        catalogsStore.addADP2(r2.value);
        catalogsStore.addADP3(r3.value);
        catalogsStore.addENP(r4.value);
        resolve();
      })
      .catch((err) => {
        reject();
      });
  });
}

export async function prepareCatalog() {
  // Импортируем Pinia store для каталогов
  const { useCatalogStore } = await import('@/stores/catalog')
  const catalogStore = useCatalogStore()
  
  catalogsStore = useCatalogsStore()
  deviceStore = useDeviceStore()

  // Проверяем, загружены ли уже все необходимые данные каталога
  const isDataAlreadyLoaded =
    catalogsStore.getCountries &&
    catalogsStore.getCountries.length > 0 &&
    catalogsStore.getItems &&
    catalogsStore.getItems.length > 0 &&
    catalogsStore.getProducts &&
    catalogsStore.getProducts.length > 0

  if (isDataAlreadyLoaded) {
    console.log('Catalog data already loaded, skipping API calls')
    return
  }

  console.log('Loading catalogs from server...')

  try {
    // Загружаем все три каталога параллельно
    await catalogStore.fetchAllCatalogs()

    const countries = catalogStore.countries
    const products = catalogStore.products
    const enc = catalogStore.enc

    // Обрабатываем данные для старого хранилища (если требуется совместимость)
    if (countries) {
      catalogsStore.addCountries(countries)
    }

    if (products) {
      // Обработка данных продуктов (аналогично старой логике)
      let itemsS57 = {}
      let linksS57 = {}

      const indexENC = products.productTypes.findIndex(
        (a) => a.description === 'S-57 ENC'
      )
      const productsS57 = products.productTypes.at(indexENC).productList.products

      productsS57.forEach((product) => {
        if (product.productCellList) {
          if (product.productCellList.productCells.length > 1) {
            itemsS57[product.id] = product
          }
          product.productCellList.productCells.forEach((cell) => {
            linksS57[cell.id] = product.id
          })
        }
      })

      catalogsStore.addProducts(productsS57)
      catalogsStore.addMultiItems(itemsS57)
      catalogsStore.addLinks(linksS57)
    }

    if (enc) {
      // Обработка ENC данных
      let mapInfos = enc
      let errorFlag = false
      let links = catalogsStore.links

      if (mapInfos && Array.isArray(mapInfos)) {
        mapInfos.forEach((item) => {
          item.productId = links[item.id]
          if (!item.productId) {
            console.log('MISSING, ' + item.id)
            errorFlag = true
          }
        })

        if (errorFlag) {
          console.warn('Some ENC items are missing product links')
        }

        catalogsStore.addItems(mapInfos)
      }
    }

    console.log('✅ Catalogs loaded successfully')
    console.log('Load results:', {
      countries: countries ? `${countries.length} items` : 'failed',
      products: products ? 'success' : 'failed',
      enc: enc ? `${enc.length} items` : 'failed'
    })
  } catch (error) {
    console.error('Failed to load catalogs:', error)
    throw error
  }
}

export function sendPurchaseRequest(data) {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/purchase/charts/todevice/v2";
    myAxios
      .post(URL, data)
      .then((resp) => {
        // Для Stripe оплаты возвращаем данные ответа (содержит orderId)
        if (data.paymentMethod === "stripe") {
          resolve(resp.data);
        } else {
          resolve();
        }
      })
      .catch((err) => {
        console.error("Error in sendPurchaseRequest:", err);
        // notificationService.error("An error occurred, please reload the page and try again");
        reject(err);
      });
  });
}

// Функция для получения URL оплаты через Stripe
export function sendStripePaymentRequest(orderId) {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/orders/pay/" + orderId;
    myAxios
      .post(URL)
      .then((resp) => {
        // Возвращаем URL оплаты Stripe
        resolve(resp.data);
      })
      .catch((err) => {
        console.error("Error in sendStripePaymentRequest:", err);
        reject(err);
      });
  });
}

export function sendUpdateRequest(data, id) {
  return new Promise((resolve) => {
    let URL = "/api/v2/order/" + id + "/update-items";
    myAxios
      .post(URL, data)
      .then((resp) => {
        resolve();
      })
      .catch((err) => {
        // TODO
        resolve();
      });
  });
}

export function loadOrder(id) {
  return new Promise((resolve) => {
    let URL = "/api/v1/order/" + id;
    myAxios
      .get(URL)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        // TODO
        resolve();
      });
  });
}

export function registerECDIS(data) {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/ecdis/register";
    myAxios
      .post(URL, data)
      .then((resp) => {
        resolve();
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

export function updateECDIS(data) {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/ecdis/update";
    myAxios
      .post(URL, data)
      .then((resp) => {
        resolve();
      })
      .catch((err) => {
        // TODO
        reject();
      });
  });
}

export function loadZOC(data) {
  return new Promise((resolve) => {
    let URL = "/api/v1/zoc_list";
    myAxios
      .post(URL, data)
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        // TODO
        resolve();
      });
  });
}

export function loadTides(date, lat, lon, days = 1) {
  return new Promise((resolve) => {
    let URL =
      "https://www.worldtides.info/api/v3?heights&datum=CD&timezone&step=3600&date=" +
      date +
      "&lat=" +
      lat +
      "&lon=" +
      lon +
      "&days=" +
      days +
      "&key=4a124677-faa6-45dc-9772-b0ffdb6d62bb";
    axios.get(URL).then((resp) => {
      resolve(resp.data);
    });
  });
}

export function loadTidesPlot12(date, lat, lon) {
  return new Promise((resolve) => {
    let URL =
      "https://www.worldtides.info/api/v3?heights&datum=CD&plot&date=" +
      date +
      "&lat=" +
      lat +
      "&lon=" +
      lon +
      "&days=1&key=4a124677-faa6-45dc-9772-b0ffdb6d62bb";
    axios.get(URL).then((resp) => {
      resolve(resp.data);
    });
  });
}

export function sendECDISRequest(type, deviceId) {
  return new Promise((resolve) => {
    let datetime = new Date().toISOString();
    let URL =
      "api/v1/userfile?device_id=" +
      deviceId +
      "&type=logbookRequest_" +
      type +
      "&path=logbook\\" +
      deviceId +
      "\\request&time=" +
      datetime;
    myAxios
      .post(URL, { request: type })
      .then((resp) => {
        resolve();
      })
      .catch((err) => {
        // TODO
        resolve();
      });
  });
}

export function saveLogbook(data, deviceId) {
  return new Promise((resolve) => {
    let datetime = new Date().toISOString();
    let URL =
      "api/v1/userfile?device_id=" +
      deviceId +
      "&type=logbook_record&path=logbook\\" +
      deviceId +
      "\\record&time=" +
      datetime;
    myAxios
      .post(URL, data)
      .then((resp) => {
        resolve();
      })
      .catch((err) => {
        // TODO
        resolve();
      });
  });
}

export function loadLogbook(deviceId) {
  const logbookStore = useLogbookStore();
  logbookStore.reset();

  return new Promise((resolve) => {
    const URL = `api/v1/userfiles?deviceId=${deviceId}`;

    myAxios
      .get(URL)
      .then((resp) => {
        const { userFiles = [] } = resp.data;

        // Find relevant files from the response
        const logbookRecord = userFiles.find(
          (file) => file.name === "record" && file.type === "logbook_record"
        );

        const ecdisMessageRecord = userFiles.find(
          (file) => file.name === "Update.txt" && file.type === "message"
        );

        const ecdisRoute = userFiles.find(
          (file) => file.name === "Route.rtz" && file.type === "route"
        );

        // Process route data if it exists
        processRouteData(ecdisRoute);

        // Process logbook and ECDIS message data
        if (logbookRecord) {
          fetchLogbookRecord(logbookRecord.id)
            .then((logRecords) => {
              if (ecdisMessageRecord) {
                return fetchEcdisMessages(ecdisMessageRecord.id, deviceId).then(
                  () => resolve(logRecords)
                );
              }
              return resolve(logRecords);
            })
            .catch(() => resolve());
        } else if (ecdisMessageRecord) {
          fetchEcdisMessages(ecdisMessageRecord.id, deviceId).then(() =>
            resolve([])
          );
        } else {
          resolve([]);
        }
      })
      .catch(() => resolve());
  });

  // Helper function to process route data
  function processRouteData(ecdisRoute) {
    if (!ecdisRoute) return;

    const URL = `api/v1/userfile/${ecdisRoute.id}`;
    myAxios.get(URL).then((resp) => {
      if (resp.data.length <= 10) return;

      const options = {
        ignoreAttributes: false,
        compact: true,
      };
      const parser = new fxparser.XMLParser(options);
      const xml = parser.parse(resp.data);
      const points = xml.route.waypoints.waypoint;

      const coordinates = points.map((waypoint) => ({
        lat: waypoint.position["@_lat"],
        lon: waypoint.position["@_lon"],
      }));

      eventBus.$emit("draw-ecdis-route", coordinates);
    });
  }

  // Helper function to fetch logbook record data
  function fetchLogbookRecord(recordId) {
    return new Promise((resolve, reject) => {
      const URL = `api/v1/userfile/${recordId}`;
      myAxios
        .get(URL)
        .then((resp) => resolve(resp.data))
        .catch(reject);
    });
  }

  // Helper function to fetch and process ECDIS messages
  function fetchEcdisMessages(messageId, deviceId) {
    return new Promise((resolve, reject) => {
      const URL = `api/v1/userfile/${messageId}`;
      myAxios
        .get(URL)
        .then((resp) => {
          const ecdisMessages = resp.data.messages.map((message) => ({
            source: "ecdis",
            time: message.timestamp,
            hdg: message?.hdg ?? 0,
            rot: message?.rot ?? 0,
            cog: message?.cog ?? 0,
            sog: message?.sog ?? 0,
            message: message.message,
            pos: {
              lat: message?.lat ?? "",
              lon: message?.lon ?? "",
            },
            images: [],
            audio: {
              src: null,
              blob: null,
            },
            deviceId,
          }));

          logbookStore.initEcdisMessages(ecdisMessages);
          resolve();
        })
        .catch(reject);
    });
  }
}

// Функция для подбора карт по прямоугольной области
export function getMapsByArea(bounds, provider) {
  return new Promise((resolve, reject) => {
    let URL = "/api/v1/maps-by-bbox";

    let request = {};

    // Формируем запрос в зависимости от провайдера
    if (provider === "Primar") {
      request = {
        Providers: ["Primar"],
        north: bounds.north,
        east: bounds.east,
        south: bounds.south,
        west: bounds.west,
      };
    } else if (provider === "UKHO") {
      request = {
        Providers: ["avcs", "enp", "tide", "light", "radio"],
        north: bounds.north,
        east: bounds.east,
        south: bounds.south,
        west: bounds.west,
      };
    } else {
      // По умолчанию используем Primar
      request = {
        Providers: ["Primar"],
        north: bounds.north,
        east: bounds.east,
        south: bounds.south,
        west: bounds.west,
      };
    }

    console.log("Запрос карт по области:", request);

    myAxios
      .post(URL, request)
      .then((resp) => {
        console.log("Ответ карт по области:", resp.data);

        // Извлекаем карты из ответа
        const maps = {
          avcs: [],
          enp: [],
          adp: [],
        };

        if (Array.isArray(resp.data)) {
          resp.data.forEach((providerData) => {
            if (
              providerData.provider === "avcs" ||
              providerData.provider === "Primar"
            ) {
              maps.avcs = providerData.maps || [];
            } else if (providerData.provider === "enp") {
              maps.enp = providerData.maps || [];
            } else if (
              ["tide", "light", "radio"].includes(providerData.provider)
            ) {
              maps.adp = [...maps.adp, ...(providerData.maps || [])];
            }
          });
        }

        resolve(maps);
      })
      .catch((err) => {
        console.error("Ошибка при получении карт по области:", err);
        reject(err);
      });
  });
}
